module.exports = __webpack_public_path__ + "static/media/attachments.feac93e5.svg";